import RepositoryFactory from "@/marcom/Apicall/RepositoryFactory";
// const smsCampaign = RepositoryFactory.smsCampaign;

export default {
  createPushNotification({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } =
          await RepositoryFactory.pushNotification.createPushNotification(
            payload
          );

        commit("SET_PUSH_NOTIFICATION_CAMPAIGN_DETAILS", {
          key: "pushNotifications",
          value: data.data,
        });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  getAllRegisteredUser({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data =
          await RepositoryFactory.pushNotification.getAllRegisteredUsers(
            payload
          );

        commit("GET_ALL_REGISTERED_USERS", {
          key: "getAllRegisteredUser",
          value: data.data.data,
        });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  getAllCampaignReport({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data =
          await RepositoryFactory.pushNotification.getAllCampaignReports(
            payload
          );

        commit("GET_ALL_CAMPAIGN_REPORTS", {
          key: "campaignReports",
          value: data.data.data,
        });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  getAllApiReport({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await RepositoryFactory.pushNotification.getAllApiReports(
          payload
        );

        commit("GET_ALL_API_REPORTS", {
          key: "apiReports",
          value: data.data.data,
        });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  getAllNotificationTemplate({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } =
          await RepositoryFactory.pushNotification.getAllNotificationTemplate(
            payload
          );

        commit("GET_ALL_NOTIFICATION_TEMPLATE", data.data);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  createPushNotificationTemplate({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } =
          await RepositoryFactory.pushNotification.createTemplate(payload);

        commit("SET_PUSH_NOTIFICATION_TEMPLATE", {
          key: "pushNotifications",
          value: data.data,
        });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
